import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { TextField, FontIcon } from 'material-ui';
import { contains } from 'ramda';

const Search = props => {
  const {
    sendToPartners,
    updateProps,
  } = props;

  return (
    <div style={{ width: '100%', borderBottom: '1px solid #e0e0e0', marginTop: '-10px' }}>
      <FontIcon className="tc-icon-search" color="rgba(0,0,0,0.5)" style={{ top: '5px', margin: '0 2% 0 7.5%' }} />
      <TextField
        underlineShow={false}
        inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', padding: '0px 3px' }}
        value={sendToPartners.searchField}
        onChange={({ target: { value } }) => {
          updateProps({
            searchField: value,
            filteredConnections: sendToPartners.existingConnections.filter(connection => {
              if ((connection.companyName && contains(value.toLowerCase(), connection.companyName.toLowerCase())) ||
                (connection.email && connection.email !== 'via TourConnect' && contains(value.toLowerCase(), connection.email.toLowerCase()))) {
                if (sendToPartners.selectedTag) return contains(sendToPartners.selectedTag, connection.tags);
                return true;
              }
            }),
          });
        }}
        onKeyDown={e => (e.which === 13 || e.which === 9) ? e.preventDefault() : undefined}
        hintText="Search company name or email"
        hintStyle={{ marginLeft: '3px' }}
      />
    </div>
  );
};

Search.propTypes = {
  updateProps: PropTypes.func,
  sendToPartners: PropTypes.object,
};

const mapStateToProps = ({ contracting }) => ({
  sendToPartners: contracting.sendToPartners.toJS(),
});

export default connect(mapStateToProps)(Search);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/send-to-partners/existing/search.jsx